import {
  Callout,
  Empty,
  Loading,
  Panel,
  SortTh,
  Sorted,
  TableScroll,
  formatCount,
  formatDay,
  sortableCell,
  type Load,
} from '@affdice/portal-kit';
import { PlatformApi } from '../../../client.ts';
import { t } from '../../../messages.ts';

/** Platform usage — what the metering job counted for this operator, period by period. */
export function PlatformUsageSection({
  usage,
}: {
  usage: Load<Awaited<ReturnType<PlatformApi['platformUsage']>>>;
}) {
  return (
    <Panel title={t('ops.usage.title')}>
      {usage.state !== 'ready' ? (
        <Loading rows={1} />
      ) : (
        <>
          <div className="figures">
            <article className="figure">
              <span className="figure-label">{t('ops.usage.liveBrands')}</span>
              <span className="figure-value">{usage.value.live.brands}</span>
            </article>
          </div>

          {/* Item 6 (third batch) — the table's two numeric columns were
              bare labels. "Units" and "overage" mean something specific
              here, and reading a bill off figures whose definition you are
              guessing at is how a billing dispute starts. */}
          <Callout>
            <strong>{t('ops.usage.unitsTerm')}</strong>{' '}{t('ops.usage.unitsText')}{' '}
            <strong>{t('ops.usage.overageTerm')}</strong>{' '}{t('ops.usage.overageText')}{' '}
            {t('ops.usage.bothNote')}
          </Callout>

          {usage.value.items.length === 0 ? (
            <Empty>{t('ops.usage.none')}</Empty>
          ) : (
            <Sorted rows={usage.value.items} by={{ metric: (row) => sortableCell(row.metric), period_start: (row) => sortableCell(row.period_start), units: (row) => sortableCell(row.units), overage_units: (row) => sortableCell(row.overage_units) }}>
              {(ordered, sort) => (
            <TableScroll>
              <table>
                <thead>
                  <tr><SortTh sort={sort} col="metric">{t('ops.usage.metric')}</SortTh><SortTh sort={sort} col="period_start">{t('common.period')}</SortTh><SortTh sort={sort} col="units" align="num">{t('ops.usage.units')}</SortTh><SortTh sort={sort} col="overage_units" align="num">{t('ops.usage.overage')}</SortTh></tr>
                </thead>
                <tbody>
                  {ordered.map((row) => (
                    <tr key={`${row.metric}-${row.period_start}`}>
                      <td>{row.metric}</td>
                      {/* §22.1 — a bare `YYYY-MM-DD` from billing.ts's
                          `to_char(period_start, 'YYYY-MM-DD')`, not an
                          instant; formatDate would shift it a day either
                          side of UTC midnight. */}
                      <td>{formatDay(row.period_start)}</td>
                      <td className="num">{formatCount(Number(row.units))}</td>
                      <td className="num">{formatCount(Number(row.overage_units))}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </TableScroll>
              )}
            </Sorted>
          )}
          <Callout>{usage.value.note}</Callout>
        </>
      )}
    </Panel>
  );
}
